jQuery(document).ready(function($) {

    // GA4 Checkout & journey events

    // GA4 - Checkout Journey - 1. init_checkout
    $("body").on("init_checkout", function (e) {

        alert('init_checkout event detected');

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: "POST",
            dataType: "json",
            data: {
            action: "get_cart_data_for_gtag"
            },
            success: function(response) {
                console.log("Cart data for gtag:", response);
                if (response.success) {
                    const cartData = response.data;
                    
                    gtag("event", "begin_checkout", {
                        value: cartData.value,
                        currency: cartData.currency,
                        items: cartData.items
                    });

                    // Facebook Pixel
                    fbq('track', 'InitiateCheckout', {
                        contents: cartData.items,
                        currency: cartData.currency,
                        num_items: cartData.items.length,
                        value: cartData.value,
                    });

                } else {
                    console.warn("No se pudo obtener datos del carrito:", response.data);
                }
            },
            error: function(xhr, status, error) {
                console.error("Error en la llamada AJAX:", error);
            }
        });
    });

    // GA4 - Checkout Journey - 2. add_shipping_info
    // Registrar evento add_shipping_info cuando el usuario pasa a la siguiente etapa de checkout sin errores
    /* $("body").on("click", "#form_actions[data-step=billing] [name=checkout_next_step]", function() {

        // Wait for yith to validate billing fields (no plugin js events available)
        setTimeout(function() {
            if (jQuery("#order_info").is(":visible")) {

                let order_details = get_checkout_order_details();
                let total = order_details.total;
                let items = order_details.items;
                
                gtag("event", "add_shipping_info", {
                    currency: "EUR",
                    value: total,
                    items: items,
                });
            }
        }, 2500);
    }) */

    // GA4 - Checkout Journey - 3. add_payment_info
    // Registrar evento add_payment_info cuando el usuario procede a realizar el pago
    /* $("body").on('click', '#place_order', function() {

        // Verificar si el checkbox de términos y condiciones está marcado, ya que sinó no debería enviarse el evento
        if ($("form[name=checkout] #terms").is(":checked")) {

            let order_details = get_checkout_order_details();
            let payment_method = order_details.payment_method;
            let total = order_details.total;
            let items = order_details.items;
            
            // Enviar evento a Google Tag Manager
            gtag('event', 'add_payment_info', {
                currency: 'EUR',
                value: total,
                payment_type: payment_method,
                items: items
            });
        }
    }) */

    // GA4 - Checkout Journey - 4. see in functions.php ('woocommerce_thankyou' hook)

})